export default __webpack_public_path__ + "static/media/logo.f6a13a4f.png";